export default "__VITE_ASSET__CJnMWc1S__"